<div class="w-12 p-b-3-m p-b-3-s search"
  [class.is-focus]="isFocus"
  (offClick)="close()"
  [offClickOff]="!isFocus"
  offClickFilter="search-outlet,search-content-block,.search-modal,.search-outlet-modal,.search__bg">

  <div class="search__bg"></div>

  <!-- search input -->
  <div class="pos-relative search__input"
    sizeClass="S:form-size-1">
    <input class="input search-input"
      type="text"
      cy-searchInput
      [(ngModel)]="term"
      (keyup)="keyup($event)"
      autofocus="true"
      #input
      placeholder="What are you looking for?">

    @if (status && status.busy) {
      <div class="pos-absolute top-0 right-8 bottom-0 flex flex-middle p-a-2 col-13"
        >
        <i class="icon-loading"></i>
      </div>
    }

    <button type="button"
      class="pos-absolute top-0 right-1 bottom-0 flex flex-middle p-a-2"
      (click)="goToSearch()">
      <i class="icon-search"
        cy-searchInputSubmit
      [style.font-size.rem]="1.2"></i>
    </button>
  </div>
  <!-- (click)="reset()" -->
  <button type="button"
    class="pos-absolute top-0 right-0 bottom-0 z-1 flex flex-middle p-a-2 p-r-9"
    (click)="close()">
    <i class="icon-close"></i>
  </button>
</div>
